import { NotificationIcon } from '@practium/ui';
import styles from './NotificationBadge.module.css';

interface NotificationBadgeProps {
	count?: number;
	onClick?: () => void;
}

export const NotificationBadge = ({ count = 0, onClick }: NotificationBadgeProps) => {
	return (
		<button
			className={styles.notificationButton}
			onClick={onClick}
			aria-label={`${count} notificações`}
		>
			<NotificationIcon className={styles.notificationIcon} />
			{count > 0 && <span className={styles.badge}></span>}
		</button>
	);
};
